import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Auth/Login";
import Dashboard from "./components/Dashboard";
import { ToastContainer } from "react-toastify";
import Register from "./components/Auth/Register";
import Nav from "./components/Nav";

function App() {
  const [loggedIn, setLoggedIn] = useState("");
  useEffect(() => {
    setLoggedIn(localStorage.getItem("token"));
  }, []);
  return (
    <BrowserRouter>
      <ToastContainer />
      <Nav loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
      <Routes>
        <Route
          path="/"
          element={
            loggedIn ? (
              <Dashboard loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
            ) : (
              <Login setLoggedIn={setLoggedIn} />
            )
          }
        />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={<Dashboard setLoggedIn={setLoggedIn} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
